import { render, staticRenderFns } from "./ArtistGroupMembers.vue?vue&type=template&id=6baf8f03&scoped=true"
import script from "./ArtistGroupMembers.vue?vue&type=script&lang=js"
export * from "./ArtistGroupMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baf8f03",
  null
  
)

export default component.exports